export type HardwareTier = 'high' | 'medium' | 'low';

export function detectHardwareTier(
  gl: WebGLRenderingContext | WebGL2RenderingContext | null,
): HardwareTier {
  if (!gl) {
    return 'low';
  }

  // Get GPU info
  const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
  const renderer = debugInfo
    ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
    : '';
  const vendor = debugInfo
    ? gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)
    : '';

  // Check for mobile GPUs
  const isMobileGPU =
    /Mobile|Android|iPhone|Qualcomm|ARM|Samsung|Immortalis/i.test(renderer) ||
    /Mobile|Android|iPhone|Qualcomm|ARM|Samsung|Immortalis/i.test(vendor);

  // Check for integrated GPUs
  const isIntegratedGPU =
    /Intel/i.test(renderer) && !/NVIDIA|AMD/i.test(renderer);

  // Check for dedicated GPUs
  const isDedicatedGPU = /NVIDIA|AMD|Radeon/i.test(renderer);

  // Check device memory
  const deviceMemory = (navigator as any).deviceMemory || 0;

  let tier: HardwareTier;
  if (isMobileGPU || isIntegratedGPU || deviceMemory < 4) {
    tier = 'low';
  } else if (isDedicatedGPU && deviceMemory >= 8) {
    tier = 'high';
  } else {
    tier = 'medium';
  }

  console.log('Hardware Detection:', {
    tier,
    renderer,
    vendor,
    deviceMemory,
    isMobileGPU,
    isIntegratedGPU,
    isDedicatedGPU,
  });

  return tier;
}
